const C = {
  bg: "#0a0a0a",
  text: "#f5f5f5",
  muted: "#888888",
  bordeaux: "#6d0000",
  border: "#222222",
  card: "#141414",
};

const LOGO_URL = "/manus-storage/logo_2d439bd1.jpg";

export default function Datenschutz() {
  return (
    <div style={{ minHeight: "100vh", backgroundColor: C.bg, color: C.text, fontFamily: "'DM Sans', sans-serif" }}>
      {/* Bordeaux-Akzentlinie */}
      <div style={{ height: "4px", backgroundColor: C.bordeaux }} />

      {/* Header */}
      <header style={{ padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: `1px solid ${C.border}`, backgroundColor: C.bg }}>
        <a href="/" style={{ display: "flex", alignItems: "center", gap: "12px", textDecoration: "none" }}>
          <img src={LOGO_URL} alt="WERBEAGENTUR Larissa Girenko" style={{ width: "40px", height: "40px", objectFit: "contain" }} />
          <div>
            <span style={{ fontFamily: "'Bebas Neue', sans-serif", fontWeight: 700, fontSize: "14px", letterSpacing: "0.1em", textTransform: "uppercase" as const, color: C.text }}>
              WERBEAGENTUR Larissa Girenko
            </span>
          </div>
        </a>
        <a href="/" style={{ color: C.muted, fontSize: "13px", textDecoration: "none" }}>← Zurück zur Startseite</a>
      </header>

      {/* Inhalt */}
      <main style={{ maxWidth: "800px", margin: "0 auto", padding: "48px 24px 80px" }}>
        <h1 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "42px", letterSpacing: "0.05em", color: C.bordeaux, marginBottom: "8px" }}>
          Datenschutzerklärung
        </h1>
        <p style={{ color: C.muted, marginBottom: "40px", fontSize: "14px" }}>
          Stand: Juni 2026 · WERBEAGENTUR Larissa Girenko
        </p>

        <Section title="1. Verantwortliche Stelle">
          <p>Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne der DSGVO ist:</p>
          <p style={{ marginTop: "12px", backgroundColor: C.card, padding: "16px", borderLeft: `3px solid ${C.bordeaux}` }}>
            <strong>WERBEAGENTUR Larissa Girenko</strong><br />
            Inhaberin: Larissa Girenko<br />
            Lutherstr. 16 c, 04315 Leipzig<br />
            E-Mail: <a href="mailto:info@werbeagentur.me" style={{ color: C.bordeaux }}>info@werbeagentur.me</a><br />
            Website: <a href="https://werbeagentur.me" style={{ color: C.bordeaux }}>werbeagentur.me</a>
          </p>
        </Section>

        <Section title="2. Erhobene Daten und Zweck der Verarbeitung">
          <SubSection title="2.1 Website-Analyse (Barometer-Tools)">
            <p>
              Wenn du eine Website-URL zur Analyse eingibst, wird diese URL an unseren Server übermittelt und dort von einem automatisierten Analyse-Skript verarbeitet. Die analysierte URL wird ausschließlich für die Durchführung der Analyse verwendet und nicht dauerhaft gespeichert oder an Dritte weitergegeben.
            </p>
            <p style={{ marginTop: "8px" }}>
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung / vorvertragliche Maßnahmen).
            </p>
          </SubSection>

          <SubSection title="2.2 Zahlungsabwicklung (kostenpflichtige Produkte)">
            <p>
              Für alle kostenpflichtigen Produkte (Website-RealitätsCheck™, Marketing-RealitätsCheck™, Komplett-Paket, Google Ads Potenzialanalyse™ und weitere) wird die Zahlung über <strong>Stripe</strong> (Stripe, Inc., 510 Townsend Street, San Francisco, CA 94103, USA) abgewickelt. Dabei werden deine Zahlungsdaten (Kreditkartennummer, Name, E-Mail) direkt an Stripe übermittelt. Wir erhalten lediglich eine Bestätigung der Zahlung sowie eine anonymisierte Transaktions-ID. Stripe verarbeitet deine Daten gemäß der{" "}
              <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer" style={{ color: C.bordeaux }}>Stripe-Datenschutzrichtlinie</a>.
            </p>
            <p style={{ marginTop: "8px" }}>
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO.
            </p>
          </SubSection>

          <SubSection title="2.3 Terminbuchung (Meetergo)">
            <p>
              Für die Buchung von Terminen (z. B. Video-Call zur Besprechung der Google Ads Potenzialanalyse) nutzen wir den Dienst <strong>Meetergo</strong> (Meetergo GmbH, Deutschland). Wenn du über den Buchungslink einen Termin buchst, werden deine Kontaktdaten (Name, E-Mail-Adresse, ggf. Telefonnummer) sowie der gewählte Termin an Meetergo übermittelt und dort verarbeitet. Meetergo verarbeitet diese Daten gemäß seiner{" "}
              <a href="https://meetergo.com/datenschutz" target="_blank" rel="noopener noreferrer" style={{ color: C.bordeaux }}>Datenschutzerklärung</a>.
            </p>
            <p style={{ marginTop: "8px" }}>
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung / vorvertragliche Maßnahmen).
            </p>
          </SubSection>

          <SubSection title="2.4 Kontaktformular">
            <p>
              Wenn du das Kontaktformular verwendest, werden deine Angaben (Name, E-Mail, Nachricht, ggf. Website-URL) zur Bearbeitung deiner Anfrage gespeichert. Diese Daten werden nicht an Dritte weitergegeben und nach Abschluss der Anfrage gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
            </p>
            <p style={{ marginTop: "8px" }}>
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO.
            </p>
          </SubSection>

          <SubSection title="2.5 Server-Logs">
            <p>
              Beim Aufruf unserer Website werden automatisch folgende Daten in Server-Logs gespeichert: IP-Adresse (anonymisiert), Datum und Uhrzeit des Zugriffs, aufgerufene URL, HTTP-Statuscode, übertragene Datenmenge, Referrer-URL, Browser-Typ und Betriebssystem. Diese Daten werden ausschließlich zur Sicherstellung des technischen Betriebs und zur Abwehr von Angriffen verwendet und nach 7 Tagen automatisch gelöscht.
            </p>
            <p style={{ marginTop: "8px" }}>
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Sicherheit und Betrieb).
            </p>
          </SubSection>
        </Section>

        <Section title="3. Cookies und lokale Speicherung">
          <SubSection title="3.1 Technisch notwendige Cookies">
            <p>
              Wir verwenden Session-Cookies, die für den technischen Betrieb der Website zwingend erforderlich sind (z. B. Authentifizierungs-Tokens nach dem Login). Diese Cookies werden ohne deine Einwilligung gesetzt, da sie für die Funktionsfähigkeit der Website notwendig sind.
            </p>
            <p style={{ marginTop: "8px" }}>
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO i. V. m. § 25 Abs. 2 TDDDG.
            </p>
          </SubSection>

          <SubSection title="3.2 Analyse-Cookies (nur mit Einwilligung)">
            <p>
              Mit deiner Einwilligung setzen wir <strong>Umami Analytics</strong> ein – ein datenschutzfreundliches Analyse-Tool, das keine personenbezogenen Daten erhebt, keine Cookies setzt und keine IP-Adressen speichert. Umami erfasst ausschließlich anonyme Seitenaufruf-Statistiken.
            </p>
            <p style={{ marginTop: "8px" }}>
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung). Du kannst deine Einwilligung jederzeit widerrufen, indem du im Cookie-Banner auf „Nur notwendige" klickst oder den localStorage-Eintrag <code style={{ backgroundColor: "#222", padding: "2px 6px" }}>cookie_consent_v1</code> löschst.
            </p>
          </SubSection>

          <SubSection title="3.3 Schriftarten (lokal eingebettet)">
            <p>
              Die auf dieser Website verwendeten Schriftarten (Bebas Neue, DM Sans) werden lokal über ein Content Delivery Network (CDN) eingebettet. Es findet keine Verbindung zu Google-Servern statt. Es werden keine personenbezogenen Daten an Dritte übertragen.
            </p>
          </SubSection>
        </Section>

        <Section title="4. Widerrufsrecht bei digitalen Produkten">
          <p>
            Bei digitalen Produkten (z. B. Website-Analysen, Reports, Potenzialanalysen) gilt grundsätzlich ein 14-tägiges Widerrufsrecht nach § 355 BGB. Das Widerrufsrecht erlischt gemäß § 356 Abs. 5 BGB vorzeitig, wenn wir mit der Ausführung des Vertrags begonnen haben und du ausdrücklich zugestimmt hast, dass wir vor Ablauf der Widerrufsfrist mit der Ausführung beginnen, und du zur Kenntnis genommen hast, dass du dein Widerrufsrecht mit Beginn der Ausführung verlierst.
          </p>
          <p style={{ marginTop: "8px" }}>
            Zur Ausübung deines Widerrufsrechts wende dich an: <a href="mailto:info@werbeagentur.me" style={{ color: C.bordeaux }}>info@werbeagentur.me</a>
          </p>
        </Section>

        <Section title="5. Weitergabe von Daten an Dritte">
          <p>Wir geben deine personenbezogenen Daten nur weiter, wenn:</p>
          <ul style={{ paddingLeft: "20px", lineHeight: 2 }}>
            <li>du ausdrücklich eingewilligt hast (Art. 6 Abs. 1 lit. a DSGVO),</li>
            <li>dies zur Vertragserfüllung notwendig ist (z. B. Stripe für Zahlungen, Meetergo für Terminbuchungen),</li>
            <li>wir gesetzlich dazu verpflichtet sind,</li>
            <li>dies zur Wahrung berechtigter Interessen erforderlich ist und deine Interessen nicht überwiegen.</li>
          </ul>
          <p style={{ marginTop: "12px" }}>Eine Weitergabe an Werbetreibende, Datenhändler oder sonstige Dritte findet nicht statt.</p>
        </Section>

        <Section title="6. Deine Rechte">
          <p>Du hast gegenüber uns folgende Rechte hinsichtlich deiner personenbezogenen Daten:</p>
          <ul style={{ paddingLeft: "20px", lineHeight: 2, marginTop: "8px" }}>
            <li><strong>Auskunftsrecht</strong> (Art. 15 DSGVO)</li>
            <li><strong>Recht auf Berichtigung</strong> (Art. 16 DSGVO)</li>
            <li><strong>Recht auf Löschung</strong> (Art. 17 DSGVO)</li>
            <li><strong>Recht auf Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO)</li>
            <li><strong>Recht auf Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
            <li><strong>Widerspruchsrecht</strong> (Art. 21 DSGVO)</li>
            <li><strong>Recht auf Widerruf</strong> erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO)</li>
          </ul>
          <p style={{ marginTop: "12px" }}>
            Zur Ausübung deiner Rechte wende dich an: <a href="mailto:info@werbeagentur.me" style={{ color: C.bordeaux }}>info@werbeagentur.me</a>
          </p>
          <p style={{ marginTop: "8px" }}>
            Du hast außerdem das Recht, dich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Die zuständige Behörde richtet sich nach deinem Wohnsitz. Für Sachsen ist dies der <strong>Sächsische Datenschutzbeauftragte</strong>, Devrientstraße 5, 01067 Dresden.
          </p>
        </Section>

        <Section title="7. Datensicherheit">
          <p>Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um deine Daten vor unberechtigtem Zugriff, Verlust oder Manipulation zu schützen. Dazu gehören:</p>
          <ul style={{ paddingLeft: "20px", lineHeight: 2, marginTop: "8px" }}>
            <li>Verschlüsselte Übertragung via HTTPS (TLS)</li>
            <li>HTTP Security-Header (HSTS, X-Frame-Options, Content-Security-Policy)</li>
            <li>Rate-Limiting zum Schutz vor automatisierten Angriffen</li>
            <li>Regelmäßige Sicherheitsupdates</li>
          </ul>
        </Section>

        <Section title="8. Änderungen dieser Datenschutzerklärung">
          <p>
            Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen, um sie an geänderte Rechtslage oder bei Änderungen des Dienstes anzupassen. Die aktuelle Version ist stets unter <a href="/datenschutz" style={{ color: C.bordeaux }}>/datenschutz</a> abrufbar.
          </p>
        </Section>

        <div style={{ marginTop: "48px", paddingTop: "24px", borderTop: `1px solid ${C.border}`, color: C.muted, fontSize: "13px" }}>
          <a href="/impressum" style={{ color: C.bordeaux, marginRight: "24px" }}>Impressum</a>
          <a href="/" style={{ color: C.muted }}>Zurück zur Startseite</a>
        </div>
      </main>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section style={{ marginBottom: "36px" }}>
      <h2 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "22px", letterSpacing: "0.05em", color: "#ffffff", marginBottom: "12px", paddingBottom: "8px", borderBottom: `1px solid #222` }}>
        {title}
      </h2>
      <div style={{ color: "#cccccc", lineHeight: 1.7, fontSize: "14px" }}>{children}</div>
    </section>
  );
}

function SubSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: "16px" }}>
      <h3 style={{ fontSize: "15px", fontWeight: 600, color: "#ffffff", marginBottom: "6px" }}>{title}</h3>
      {children}
    </div>
  );
}
